var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poppins",class:{ 'sb-nav-fixed': !_vm.isLoginPage }},[(!_vm.isLoginPage)?_c('Navbar'):_vm._e(),_c('div',{attrs:{"id":_vm.layoutId}},[(!_vm.isLoginPage)?_c('SideBar'):_vm._e(),_c('div',{attrs:{"id":_vm.contentId}},[_c('router-view'),(!_vm.isLoginPage)?_c('Footer'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }